<template>
  	<v-app>
		<system-bar></system-bar>
		<!-- <v-app-bar app class="yellow darken-4"></v-app-bar> -->
		<navigation-drawer></navigation-drawer>
		<v-main>
			<v-container fluid>
				<router-view />
			</v-container>
		</v-main>
		<!-- <v-bottom-navigation app>
			<v-btn value="recent">
			<span>Recent</span>

			<v-icon>mdi-history</v-icon>
			</v-btn>

			<v-btn value="favorites">
			<span>Favorites</span>

			<v-icon>mdi-heart</v-icon>
			</v-btn>

			<v-btn value="nearby">
			<span>Nearby</span>

			<v-icon>mdi-map-marker</v-icon>
			</v-btn>
		</v-bottom-navigation> -->
		<v-footer :absolute="true" :height="15 + app.bottom_height">
			
		</v-footer>
  	</v-app>
</template>

<script>
import SystemBar from '@/components/SystemBar.vue'
import NavigationDrawer from '@/components/NavigationDrawer.vue'
import { useAppStore } from '@/stores/app'

export default {
	name: 'App',
	components: {
		SystemBar,
		NavigationDrawer
	},
	created() {
		this.app = useAppStore()
	},
	data() {
		return {
			app: null
		}
	}
};
</script>

